import * as React from "react";
import {
  AccessorFn,
  ColumnHelper,
  DeepKeys,
  DisplayColumnDef,
  RowData
} from "@tanstack/react-table";

import {
  IOrder,
  IOrderStatus
} from "src/core/orders/api/orders.api";
import OrderStatus from "src/core/orders/components/OrderStatus";

/**
 * This function returns a reusable formated column definition for order status data to be used in Tanstack tables
 *
 * @param columnHelper
 * @param accessor
 * @param column
 * @returns column definition for order status data
 */
export const orderStatusColumn = <TData extends RowData, TAccessor = AccessorFn<TData> | DeepKeys<TData>>(
  columnHelper: ColumnHelper<TData>,
  accessor: TAccessor, column:
  Partial<Pick<DisplayColumnDef<TData>, "id" | "enableSorting" | "enableColumnFilter" | "meta">>
) => {
  return columnHelper.accessor(accessor as DeepKeys<TData>, {
    id: column.id ? column.id : accessor,
    filterType: "string",
    header: "Status",
    cell: info => {
      const order = info.row.original as IOrder;

      return (
        <OrderStatus
          orderId={order.id}
          status={info.cell.getValue() as IOrderStatus}
          tooltipPlace="right"
        />
      );
    },
    enableSorting: column.enableSorting,
    enableColumnFilter: column.enableColumnFilter,
    enableResizing: true,
    minSize: 100,
    meta: {
      style: { align: "left" },
      filter: column.meta?.filter
    }
  } as DisplayColumnDef<TData>);
};
